module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zM10 23.126V8.874c0-.794 1.168-1.098 1.816-.696l11.614 7.09c.644.402.802 1.062.16 1.464l-11.856 7.09c-.642.406-1.734.094-1.734-.696z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/play-1.js
// module id = 1344
// module chunks = 14